import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { filter, Subscription } from 'rxjs';
import { StringVariable } from '../../../core/string-variable';

@Component({
  selector: 'app-auth-language-selector',
  standalone: true,
  imports: [CommonModule, BsDropdownModule],
  templateUrl: './auth-language-selector.component.html',
  styleUrl: './auth-language-selector.component.scss',
})
export class AuthLanguageSelectorComponent implements OnInit, OnDestroy {
  languages = [
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'fr',
      name: 'French',
    },
  ];

  selectedLanguage = 'English';
  showLanguageSelector = false;

  private routerSub!: Subscription;
  private langSub!: Subscription;

  private authPatterns = [
    '/login',
    '/signUp',
    '/forgot-password',
    '/change-password',
    '/twoFactor',
    '/otp-verification',
  ];

  constructor(
    public variable: StringVariable,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.updateCurrentLanguageLabel(this.variable.getCurrentLanguage());

    this.langSub = this.variable.language$.subscribe((langCode) => {
      this.updateCurrentLanguageLabel(langCode);
    });

    this.checkRoute(this.router.url);

    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.checkRoute(event.urlAfterRedirects || event.url);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  private checkRoute(url: string): void {
    if (!url) {
      this.showLanguageSelector = false;
      return;
    }
    const cleanUrl = url.split('?')[0];
    this.showLanguageSelector = this.authPatterns.some((pattern) =>
      cleanUrl.toLowerCase().includes(pattern.toLowerCase())
    );
  }

  private updateCurrentLanguageLabel(langCode: string): void {
    const found = this.languages.find((l) => l.code === langCode);
    this.selectedLanguage = found ? found.name : 'English';
  }

  changeLanguage(language: { code: string; name: string }): void {
    this.selectedLanguage = language.name;
    this.variable.setLanguage(language.code);
  }
}
